import { Column, Text, useAppPalette } from "@bridgesplit/ui";
import { COPY } from "app/constants";
import { getLoopBorrowCapDetails } from "@bridgesplit/abf-react";

import { Orderbook } from "../../market-detail/common";
import { useLoopContext } from "../LoopContext";

export function LoopAvailableLiquidity() {
    const { loopExpanded } = useLoopContext();
    const borrowCapWarning = getLoopBorrowCapDetails(loopExpanded);

    const { secondary } = useAppPalette();

    if (borrowCapWarning?.warningMessage) return null;

    return (
        <Column spacing={2}>
            <Text variant="h4">{COPY.AVAILABLE_LIQUIDITY_TERM}</Text>
            <Orderbook
                availableLiquidityBarSx={{ borderRadius: "8px 0 0 8px" }}
                availableLiquidityTextSx={{
                    color: secondary,
                    px: 0.5
                }}
                showTooltip={false}
                tickSize={100}
            />
        </Column>
    );
}
